// Portal-only dark mode. The flag lives on <html> so the auth screens, the
// signed-in shell and portalled modals all pick it up; only .lwp elements react.
const THEME_KEY = "lawyer_theme";

export const isDarkTheme = () => {
  try {
    return localStorage.getItem(THEME_KEY) === "dark";
  } catch {
    return false;
  }
};

export const applyLawyerTheme = (dark = isDarkTheme()) => {
  document.documentElement.toggleAttribute("data-lwp-dark", dark);
};

export const setDarkTheme = (dark) => {
  try {
    localStorage.setItem(THEME_KEY, dark ? "dark" : "light");
  } catch {
    // Storage unavailable — the toggle still applies for this page view.
  }
  applyLawyerTheme(dark);
};

applyLawyerTheme();
